import { render, staticRenderFns } from "./PagedGrid.vue?vue&type=template&id=1e5c2a54&scoped=true&"
import script from "./PagedGrid.vue?vue&type=script&lang=js&"
export * from "./PagedGrid.vue?vue&type=script&lang=js&"
import style0 from "./PagedGrid.vue?vue&type=style&index=0&id=1e5c2a54&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5c2a54",
  null
  
)

export default component.exports